import { HTTP_CP_Company } from '@api-new/companyservice';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CompanyState } from '@shared/store/company/company.state';

export const selectCompanyState = createFeatureSelector<CompanyState>('company');

export const selectCompany = createSelector(selectCompanyState, (state: CompanyState): HTTP_CP_Company | null => state.company || null);

export const selectIsLoadingCompany = createSelector(selectCompanyState, (state: CompanyState): boolean => state.loading);

export const selectCompanyLogo = createSelector(selectCompany, (company: HTTP_CP_Company): string | null => company?.logo || null);

export const selectCompanyTradingName = createSelector(
  selectCompany,
  (company: HTTP_CP_Company): string | null => company?.tradingName || null,
);

export const selectCompanyShowAdvisorPage = createSelector(
  selectCompany,
  (company: HTTP_CP_Company): boolean => company?.companyClientUISettings.showAdvisorPage,
);

export const selectCompanyClientUISettings = createSelector(selectCompany, (company) => company?.companyClientUISettings);

export const selectCanAccessSmartSearch = createSelector(
  selectCompanyClientUISettings,
  (companyFeaturesSettings) => companyFeaturesSettings?.showSmartSearch,
);
